import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  static targets = ['input', 'results'];

  connect() {
    this.inputTarget.addEventListener('keydown', () =>
      this.searchUsers()
    );
    this.inputTarget.addEventListener('paste', () =>
      this.searchUsers()
    );

  }

  renderResults(results) {
    let result = [];
    let link = '';
    result.push(`<button class="button is-text is-small is-fullwidth" data-action="shared--user-search#close" style="text-decoration: none;" title="Закрыть">
                  <span class="icon"><i class="fas fa-times"></i></span>
                </button>`);
    for (const r of results) {
      if (r.confirmed && r.can_be_impersonated) {
        link = `<a data-method="post" href="/office/users/${r.id}/impersonate"
                title="Притвориться">
                  <span class="icon"><i class="fas fa-user-secret"></i></span>
                </a>`;
      } else {
        link = `<span class="icon has-text-black" title="Нельзя притвориться">
                  <i class="fas fa-user-secret"></i>
                </span>`;
      }
      result.push(`
        <p class="dropdown-item false" data-id="${r.id}"
        data-name="${r.full_name}" style="border-bottom: 1px solid rgb(217, 217, 217);">
          <div class="columns without-margin-bottom is-fullwidth" style="padding-left: 10px;">
            <div class="column ${r.blocked ? 'has-text-danger' : ''}" style="max-width: 160px;">
              <span>${r.full_name}<span>
            </div>
            <div class="column is-size-7 is-narrow" style="padding-top: 15px;">
              ${r.price_policy_abbr}
            </div>
          </div>
          <div class="has-text-centered">
            <a href="/office/users/${r.id}/edit" title="Редактировать">
              <span class="icon"><i class="fas fa-edit"></i></span>
            </a>
            <a href="/office/orders?query=@${r.name_for_query}" title="Заказы">
              <span class="icon"><i class="fas fa-ruble-sign"></i></span>
            </a>
            <a href="/office/analytics/activity?searcher=user-${r.id}" title="Активность за последний месяц">
              <span class="icon"><i class="fas fa-chart-area"></i></span>
            </a>
      `)
      if (r.company && r.company.id) {
        result.push(`
          <a href="/office/companies/${r.company.id}/edit" title="Организация пользователя">
            <span class="icon"><i class="fas fa-building"></i></span>
          </a>
        `);
      }
      result.push(`
            <a href="/office/analytics/search?searcher=user-${r.id}" title="История запросов за последний месяц">
              <span class="icon"><i class="fas fa-history"></i></span>
            </a>  
      `);
      if (r.need_trash) {
      result.push(`
            <a href="/office/users/${r.id}/clear_cart?back=%2F" data-method="post" title="Очистить корзину" data-confirm="Вы уверены, что хотите очистить корзину пользователя? Это действие необратимо!">
              <span class="icon"><i class="fas fa-trash"></i></span>
            </a>  
      `);
      }
      if (r.for_admin) {
        result.push(`
          <a href="/office/users/${r.id}/location" title="Предполагаемое местоположение пользователя">
            <span class="icon"><i class="fas fa-map-marked-alt"></i></span>
          </a>
        `);
      }

      result.push(`
          <a href="/office/users/${r.id}/send_password_email" rel="nofollow" data-method="post" title="Отправить письмо с рекомендацией сменить пароль">
            <span class="icon"><i class="fas fa-envelope-open-text"></i></span>
          </a>
        `);

      result.push(`${link}</div></p>`);
    }

    if (results.length > 0) {
      this.inputTarget.closest('.dropdown').classList.add('is-active');
    } else {
      this.inputTarget.closest('.dropdown').classList.remove('is-active');
    };
    this.resultsTarget.innerHTML = result.join('');
  }

  close() {
    this.inputTarget.closest('.dropdown').classList.remove('is-active');
  }

  searchUsers() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value;
      const that = this;
      Rails.ajax({
        type: 'GET',
        url: `/office/users/search.json?query=${query}`,
        success: (data) => {
          if (data.length > 0) {
            that.renderResults(data);
          }
        },
        error: () => {
          alert('Ошибка при попытке найти клиента по вашему запросу');
        },
      });
    }, 400);
  }

}
